import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { getColor } from 'helpers/utils';
import { LineChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import {
  GridComponent,
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import FalconCardHeader from 'components/common/FalconCardHeader';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer
]);

const getOption = data => ({
  tooltip: {
    trigger: 'axis',
    padding: [7, 10],
    backgroundColor: getColor('100'),
    borderColor: getColor('100'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: params => {
      const { name, value } = params[0];
      return `Día ${name} : ${value.toLocaleString('es-ES')}`;
    },
    transitionDuration: 0
  },
  xAxis: {
    type: 'category',
    data: data.map(d => d.date),
    boundaryGap: false,
    axisLine: {
      lineStyle: {
        color: getColor('300')
      }
    },
    axisTick: { show: false },
    axisLabel: {
      color: getColor('400'),
      formatter: value => value.substring(0, 3),
      margin: 15
    },
    splitLine: {
      show: false
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: getColor('200')
      }
    },
    boundaryGap: false,
    axisLabel: {
      show: true,
      color: getColor('400'),
      margin: 15
    },
    axisTick: { show: false },
    axisLine: { show: false }
  },
  series: [
    {
      type: 'line',
      data: data.map(d => d.count),
      itemStyle: {
        color: getColor('white'),
        borderColor: getColor('primary'),
        borderWidth: 2
      },
      lineStyle: {
        color: getColor('primary')
      },
      showSymbol: false,
      symbol: 'circle',
      symbolSize: 10,
      smooth: false,
      emphasis: {
        scale: true
      }
    }
  ],
  grid: { right: '3%', left: '10%', bottom: '10%', top: '5%' }
});

const ResumeCard = ({ data, title }) => {
  return (
    <Card className="h-100 bg-white">
      <FalconCardHeader
        title={title}
        titleTag="h6"
        className="pb-0 bg-white"
        endEl={
          <Flex>
            <CardDropdown />
          </Flex>
        }
      />

      <Card.Body>
        <Row>
          {data?.length ? (
            <>
              <Col xs={12}>
                <ReactEChartsCore
                  echarts={echarts}
                  option={getOption(data)}
                  style={{ height: '18.75rem' }}
                />
              </Col>
              <Col xs={12} className="mt-3">
                <small>* cantidades / días</small>
              </Col>
            </>
          ) : (
            <Col xs={12}>No hay estadísticas disponibles en este momento.</Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

ResumeCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};

export default ResumeCard;
